import React, {Component} from 'react';
import { fetchShiftRecordDetail, attempUpdateRecordSite, attempUpdateCheckinState, attempUpdateRecordOTOffset } from 'actions/UserActions';
import {fetchConstructionList} from 'actions/ConstructionActions';
import moment from 'moment';
import { createPositionOptions, createWorkCategoryOptions} from './createPositionptions';

import {GoogleMapLoader, GoogleMap, Marker} from "react-google-maps";

const SimpleGoogleMap = (props) => {
  let options = {
    disableDefaultUI: true,
    streetViewControl: false,
    scrollwheel: false,
    draggable: false,
  }
  return (
    <section>
      <GoogleMapLoader
        containerElement={
          <div
            style={{
              height: "200px",
            }}
          />
        }
        googleMapElement={
          <GoogleMap
            defaultZoom={17}
            defaultCenter={{ lat: props.lat, lng: props.lng }}
            options={options}
          >
            <Marker position={{ lat: props.lat, lng: props.lng }} />
          </GoogleMap>
        }
      />
    </section>
  )
}

export default class EditShiftModalWithRecord extends Component {
  constructor(props) {
    super(props);
    let {record, siteList, user} = this.props;
    const maxYear = Math.max(
      ...siteList.filter(s => s.get('status') === 0)
          .map(s => s.get('year'))
      )
    this.rid = (record !== undefined? record.get('rid'): 0);
    this.state = {
      loading: true,
      selectingSite: false,
      years: siteList.filter(s => s.get('status') === 0 && s.get('year') > 0).map(s => s.get('year')).reduce((s, y) => {
        if (!s.includes(y)) s.push(y)
        return s;
      }, []).sort().reverse(),
      selectedYear: maxYear,
      selectedCid: siteList.getIn([
                    siteList.findIndex((site) => site.get('status') ===0 && (site.get('year') === maxYear || site.get('year') === 0)),
                    'cid']),
      selectedPid: record && record.get('pid') || user.get('role'),
      position_name: "-"
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (this.state.selectingSite) {
      this.setState({
        selectingSite: false
      })
    }

  }

  activeSelectingSite = () => {
    this.setState({
      selectingSite: true,
    })
  }

  dismissSelectingSite = () => {
    this.setState({
      selectingSite: false,
    })
  }

  handleSelectCid = (e) => {
    this.setState({
      selectedCid: +e.target.value,
    })
  }

  handleSelectYear = (e) => {
    this.setState({
      selectedYear: +e.target.value
    })
  }

  handleSelectedPid = (e) => {
    this.setState({
      selectedPid: e.target.value
    })
  }

  saveSiteChange = () => {
    let {selectedCid, selectedPid, uid, date, sid} = this.state;
    this.setState({
      cid: selectedCid,
      site_name: this.props.siteList.find((site) => site.get('cid') == selectedCid).get('name'),
      pid: selectedPid,
      position_name: this.props.positionList.find((p) => p.get('id') == selectedPid).get('name'),
    })
    this.props.dispatch(attempUpdateRecordSite(uid, date, sid, selectedCid, selectedPid))
    this.refresh();
    this.dismissSelectingSite();
  }

  delSiteAssignment = () => {
    let {uid, date, sid} = this.state;
    this.props.dispatch(attempUpdateRecordSite(uid, date, sid, 0));
    this.setState({cid:0})
    this.dismissSelectingSite();
  }

  handleCheckinRecordSwitch = (idx, id, status) => {
    return () => {
      this.props.dispatch(attempUpdateCheckinState(id, status, () => {
        let newCheckInRecord = this.state.checkRecords.slice();
        newCheckInRecord[idx].status = newCheckInRecord[idx].status === 0? 1: 0;
        let newState = Object.assign({}, this.state, {checkRecords: newCheckInRecord});
        this.setState(newState);
      }))
    }
  }

  handleAdjustOTOffset = (offset) => {
    let {uid, date, sid} = this.state;
    this.props.dispatch(attempUpdateRecordOTOffset(uid, date, sid, offset, () => {this.setState({
      otOffset: offset,
    })}));
  }

  tryAdjustOTOffset = (add=1) => {
    return () => {
      this.handleAdjustOTOffset(this.state.otOffset + add * this.props.sessionConfig.get(2).get('workUnitPerShift'));
    }
  }

  refresh = () => {
    let {record, date, sid, positionList} = this.props;
    let uid = record.get('uid') || 0;
    this.setState({
      loading: true,
    })
    uid > 0 &&
      fetchShiftRecordDetail(uid, date.format("YYYY-MM-DD"), sid)
        .then((response) => {
          const position = response.data.pid && positionList.find(p => p.get('id') == response.data.pid)
          const position_name = position && position.get('name') || "-"
          this.setState({loading: false, position_name, ...response.data})
        })
        .catch((error) => {

        })
  }

  componentDidMount() {
    this.props.dispatch(fetchConstructionList());
    this.refresh();
  }

  render() {
    let {
      loading, 
      selectingSite,
      years,
      selectedYear,
      selectedCid,
      selectedPid,
      sid, 
      cid, 
      site_name, 
      position_name,
      otOffset,
      date,
      checkRecords
    } = this.state;
    let {siteList, positionList, record, sessionConfig} = this.props;
    let hasAssign = cid !== 0 && cid !== null;
    let checkAt = checkRecords && checkRecords[0].checkAt;
    let isCheckin = checkAt !== null;
    let isConfirm = record && record.get('confirmAt') !== null;
    //figure is it pass the checkin time
    let shiftDisableAt = sessionConfig.getIn([sid, 'disableAt']);
    let shiftAbleAt = sessionConfig.getIn([sid, 'ableAt']);
    if (date !== undefined) date = date.split(" ")[0];
    shiftDisableAt = moment(date + ":" + shiftDisableAt, "YYYY-MM-DD:HH:mm")
                      .add((shiftAbleAt > shiftDisableAt? 1 : 0), 'days');
    let isPast = moment().diff(moment(shiftDisableAt, 'YYYY-MM-DD'), 'minutes') > 0;
    let workUnit = otOffset || 0;
    let OTConfig = sessionConfig.get(2);
    let OTWorkUnitPerShift = OTConfig.get('workUnitPerShift');

    if (sid > 1 && isCheckin) {
      let checkOut = checkRecords.length > 1 && checkRecords[1].checkAt;
      let checkOutState = checkRecords.length > 1 && checkRecords[1].status
      let status = checkRecords[0].status === 0 &&  checkOutState === 0
      if (status && checkOut) {
        checkAt = moment(checkAt, 'YYYY-MM-DD HH:mm:ss');
        checkOut = moment(checkOut, 'YYYY-MM-DD HH:mm:ss');
        let minPerShift = OTConfig.get('minPerShift');
        let minWorkTime = OTConfig.get('minWorkTime');
        let OTduration = moment.duration(checkOut.diff(checkAt));
        let minsOfOT = OTduration.hours() * 60 + OTduration.minutes();
        let shiftNumber = ~~(minsOfOT / minPerShift) + (minsOfOT % minPerShift > minWorkTime? 1 : 0);
        var shiftUnit = shiftNumber * OTWorkUnitPerShift;
      }
    }

    const SiteSelecting = (
        <div className="form-inline">
          <select value={selectedYear} onChange={this.handleSelectYear} className="form-control">
            {years.map(year => {
              return <option key={year} value={year}>工程年份-{year}</option>
            })}
          </select>
          {" "}
          <select value={selectedCid} onChange={this.handleSelectCid} className="form-control">
            {siteList
              .filter((site) => {
                return site.get('status') === 0 && (site.get('year') === 0 || site.get('year') === selectedYear)
              })
              .map((site) => (
              <option key={site.get('name')} value={site.get('cid')}>{site.get('name')}</option>
            ))}
          </select>
          {" "}
          <select value={selectedPid} onChange={this.handleSelectedPid} className="form-control">
            {createWorkCategoryOptions(positionList)}
            {createPositionOptions(positionList)}
          </select>
          {" "}
          <button className="btn btn-primary btn-xs" onClick={this.saveSiteChange}>
            儲存
          </button>
          {" "}
          <button className="btn btn-default btn-xs" onClick={this.dismissSelectingSite}>
            取消
          </button>
        </div>
    )

    const SiteHasAssignment = (
      (selectingSite?
        <div>
          {SiteSelecting}
        </div>
        :
        <div>
          <label>{site_name}({position_name})</label>
          <span>
            {" "}
            <button 
              className="btn btn-default btn-xs" 
              onClick={this.activeSelectingSite}
              disabled={isConfirm} >
              修改
            </button>
            {" "}
            <button 
              className="btn btn-danger btn-xs" 
              onClick={this.delSiteAssignment}              
              disabled={isConfirm} >
              删除
            </button>
          </span>
        </div>
      )
    )

    const SiteHasNotAssignment = (
      (selectingSite?
        <div>
          {SiteSelecting}
        </div>
        :
        <div>
          <label>沒有編更記錄</label>
          {" "}
          <button className="btn btn-default btn-xs" onClick={this.activeSelectingSite}>新增</button>
        </div>
      )
    )

    const CheckinRecord = ({idx, id, checkAt, device, lat, lng, status}) => (
      <div className="checkin-record-detail">
        <div><label>狀態:</label>{(status === 0? " 有效":" 無效")}
          {" "}
          <button 
            className="btn btn-xs btn-default" 
            onClick={this.handleCheckinRecordSwitch(idx, id, status)}
            disabled={isConfirm} >
            標為{(status !== 0? "有效":"無效")}
            </button>
        </div>
        <div><label>時間:</label>{" "}{checkAt}</div>
        <div><label>設備:</label>{" "}{device}</div>
        <div><label>定位:</label>{" "}{(lat && lng)? lat + ", " + lng: "沒有定位數據"}</div>
        {(lat && lng) &&
          <div><SimpleGoogleMap lat={lat} lng={lng} /></div>
        }
      </div>
    )

    const OTAdjustLabel = (
      <div>
        <button className="btn btn-xs btn-default"
          onClick={this.tryAdjustOTOffset(-1)}>
          -{OTWorkUnitPerShift}
        </button>
        {" "}
        <span className="label label-success status-label">
          {shiftUnit || 0} + {workUnit}
        </span>
        {" "}
        <button className="btn btn-xs btn-default"
          onClick={this.tryAdjustOTOffset(1)}>
          +{OTWorkUnitPerShift}
        </button>
      </div>
    )

    return (
      <div className="record">
        {loading ? <h2>加載中...</h2>
          : <div>
            <div className="site">
              {(hasAssign?
                  SiteHasAssignment
                :
                  SiteHasNotAssignment
              )}
            </div>
            <div className="checkin-status">
              {(isCheckin?
                <div>
                  {(sid === 2 && hasAssign?
                    OTAdjustLabel
                  :
                    <span className="label label-success status-label">已簽到</span>
                  )}
                  <div>
                  {checkRecords.map((record, idx) => 
                    <CheckinRecord 
                      idx={idx}
                      {...record} />)}
                  </div>
                  {checkRecords.length < 2 && 
                    <div>
                      <span className="label label-default status-label"
                      >未有下班紀錄</span>
                    </div>
                  }
                </div>
                :
                <div>
                  {sid === 2 && OTAdjustLabel}
                  {(!isPast?
                    <span className="label label-default status-label">未簽到</span>
                    :
                    <span className="label label-default status-label">沒有簽到記錄</span>
                  )}
                </div>
              )}
            </div>
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Schedule/EditShiftModalWithRecord.js